var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgActivitiesIconcomponent = function SvgActivitiesIconcomponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 7.5c-.825 0-1.5.675-1.5 1.5s.675 1.5 1.5 1.5v3c0 .825-.675 1.5-1.5 1.5H3c-.825 0-1.5-.675-1.5-1.5v-3a1.5 1.5 0 0 0 .008-3v-3C1.508 3.675 2.175 3 3 3h12c.825 0 1.5.675 1.5 1.5v3ZM9 10.875l2.685 1.725-.818-3.082L13.335 7.5l-3.18-.188L9 4.35 7.838 7.305l-3.18.188L7.124 9.51l-.81 3.09L9 10.875Z",
    fill: "#CECCC9"
  })));
};
export default SvgActivitiesIconcomponent;